import { Component } from 'react'
import { connect } from 'react-redux'
import { cancelReservation, fetchReservedRegItems } from '../actions'
import {
  isGiftTrackerPageReady,
  getReservedRegItems,
  getGiftsPurchasedCount,
} from '../reducers'

export const giftTrackerDataFetcher = (WrappedComponent) => {
  class GiftTrackerDataFetcher extends Component {
    componentDidMount() {
      const { fetchReservedRegItems } = this.props
      fetchReservedRegItems()
    }

    render() {
      return <WrappedComponent {...this.props} />
    }
  }

  const mapStateToProps = (state) => {
    return {
      isPageReady: isGiftTrackerPageReady(state),
      reservations: getReservedRegItems(state),
      giftsPurchasedCount: getGiftsPurchasedCount(state),
    }
  }

  return connect(mapStateToProps, { cancelReservation, fetchReservedRegItems })(
    GiftTrackerDataFetcher
  )
}
